import * as React from 'react';
import { useEffect } from 'react';
import {
    Field,
    getFormSyncErrors,
    InjectedFormProps,
    reduxForm
} from 'redux-form';
import { PrimaryButton } from '@gje/buttons/lib/primary-button';
import { getText } from '../../../../services/text/text-service';
import { addValidator, required, validateForm } from 'redux-form-validators';
import { connect } from 'react-redux';
import { BodyText, Text, Title } from '@gje/typography/lib';
import { isMobile } from 'react-device-detect';
import { Stepable } from '../../../components/StepManager/StepManager';
import { renderInput } from '../../../../utils/formUtils';
import { defaultCalculationData } from '../../../../constants/productsDefaultData/employeeHealthcare/defaultData';
import { fetchCalculationData } from '../../../../epics/calculation-data';
// import { HtmlPanel } from '../../../components/HtmlPanel/HtmlPanel';
import { ageResolver } from '../../../../services/customer/customer-service';
import classNames from 'classnames';
import { cleanError } from '../../../../actions/error-actions';
import {
    createUtagViewData,
    invokeFbq,
    invokeUtagData
} from '../../../../utils/statisticsUtils';
import {
    resolvePartnerForStats,
    validatePathName
} from '../../../../services/stats/stats-service';
import { StatsDataEnum } from '../../../../types/enums/statsDataEnum';
import Personnummer from 'personnummer';
import { HtmlPanel } from '../../../components/HtmlPanel/HtmlPanel';

const ageValidator = addValidator({
    validator: (options, value) => {
        if (ageResolver(value) <= options.minAge) {
            return {
                defaultMessage:
                    'Du måste vara över 15 år för att köpa en sjukvårdsförsäkring'
            };
        } else if (ageResolver(value) >= options.maxAge) {
            return {
                defaultMessage:
                    'Du måste vara under 66 år för att köpa en sjukvårdsförsäkring'
            };
        }
        return '';
    }
});

const cprValidator = addValidator({
    validator: (options, value, allValues) => {
        if (
            (value.length != 10 && value.length != 12) ||
            !Personnummer.valid(value)
        ) {
            return {
                defaultMessage: 'Vänligen kontrollera personnumret'
            };
        } else return '';
    }
});

let validate = validateForm({
    cpr: [
        required({ msg: 'Obligatoriskt fält' }),
        cprValidator({}),
        ageValidator({
            minAge: 15,
            maxAge: 66
        })
    ]
});

interface DispatchToProps {
    fetchCalculationData: Function;
    cleanError: Function;
}

interface StateToProps {
    templateData: any;
    firstStepForm: any;
    formErrors: any;
}

const FirstStep: React.FC<InjectedFormProps &
    DispatchToProps &
    StateToProps &
    Stepable> = ({
    handleSubmit,
    fetchCalculationData,
    goToNextStep,
    initialValues,
    cleanError,
    touch,
    formErrors,
    firstStepForm
}) => {
    useEffect(() => window.scrollTo(0, 0), []);

    useEffect(() => {
        const intervalUtag = setInterval(() => {
            //@ts-ignore
            if (window.utag) {
                invokeUtagData(
                    createUtagViewData(
                        StatsDataEnum.APPLICATION_NAME,
                        'employeeHealthCare',
                        resolvePartnerForStats(),
                        validatePathName(window.location.pathname) +
                            'sjukvardsforsakring/' +
                            StatsDataEnum.CALCULATION,
                        StatsDataEnum.PAGE_TITLE,
                        'sjukvardsforsakring',
                        StatsDataEnum.CALCULATION
                    )
                );
                clearInterval(intervalUtag);
            }
        }, 500);

        const intervalFbq = setInterval(() => {
            if (window.location.host.includes('dev' || 'test')) {
                clearInterval(intervalFbq);
            }
            //@ts-ignore
            if (window.fbq) {
                invokeFbq('sjukvardsforsakring');
                clearInterval(intervalFbq);
            }
        }, 500);
    }, []);

    useEffect(() => {
        let cpr = window.sessionStorage.getItem('healthCare_cpr');
        if (cpr) {
            if (
                (cpr.length === 12 ||
                    (cpr.length === 10 && Personnummer.valid(cpr))) &&
                ageResolver(cpr) >= 18 &&
                ageResolver(cpr) < 66
            ) {
                defaultCalculationData.cpr = cpr;
                fetchCalculationData(defaultCalculationData, goToNextStep);
            } else {
                touch('cpr');
            }
        }
        window.sessionStorage.removeItem('healthCare_cpr');
    });

    const mobileView = window.innerWidth <= 921 || isMobile;

    return (
        <div
            className={
                window.innerWidth <= 921 || isMobile
                    ? 'first-step-padding'
                    : 'first-step-padding'
            }>
            <div>
                <Title
                    tag={mobileView ? 'h4' : 'h2'}
                    children={getText(
                        'webshopsweden.products.employeeHealthcare.calculatePriceHeader'
                    )}
                    className={classNames(
                        'only-xs-margin-bottom-26',
                        mobileView ? 'margin-left-13' : 'margin-left-30'
                    )}
                />
            </div>
            <div className="row">
                <div
                    className={
                        window.innerWidth <= 921 || isMobile ? '' : 'col-sm-1-5'
                    }
                />
                <div className={'col-sm-20'}>
                    <form
                        className={classNames(
                            'row',
                            mobileView ? 'margin-left-13' : 'margin-top-80',
                            'margin-bottom-26'
                        )}
                        onSubmit={handleSubmit(v =>
                            fetchCalculationData(
                                {
                                    ...defaultCalculationData,
                                    ...v
                                },
                                goToNextStep
                            )
                        )}>
                        <div>
                            <div className={'col-sm-9'}>
                                <Field
                                    name="cpr"
                                    data={{
                                        label: getText(
                                            'webshopsweden.products.employeeHealthcare.personNumber' +
                                                ''
                                        ),
                                        placeHolder: getText(
                                            'webshopsweden.common.personNumberFieldPlaceHolder'
                                        ),
                                        type: 'number'
                                    }}
                                    component={renderInput}
                                />
                            </div>
                            <div
                                className={`col-sm-11 ${
                                    window.innerWidth <= 921 || isMobile
                                        ? ''
                                        : 'pull-right'
                                }`}>
                                <PrimaryButton
                                    borderColor={'red'}
                                    type="submit"
                                    className="first-step-button min-width-200"
                                    children={getText(
                                        'webshopsweden.products.accident.firstStepButton'
                                    )}
                                    onClick={() => {
                                        cleanError();
                                    }}
                                />
                            </div>
                        </div>
                    </form>
                    <div className="row">
                        <div className="col-sm-11">
                            <BodyText className="small-text">
                                <HtmlPanel>
                                    {getText(
                                        'webshopsweden.products.gjensidige.webshops.personal.data'
                                    )}
                                </HtmlPanel>
                            </BodyText>
                        </div>
                    </div>

                    <div className="row first-step-back-button">
                        <div className="col-sm-5">
                            <a href={'/'} onClick={() => cleanError()}>
                                <Text>
                                    {getText('webshopsweden.common.back')}
                                </Text>
                            </a>
                        </div>
                    </div>
                </div>
                <div
                    className={
                        window.innerWidth <= 921 || isMobile ? '' : 'col-sm-1-5'
                    }
                />
            </div>
        </div>
    );
};

const mapStateToProps = state => ({
    templateData: state.templateData.templateData,
    formErrors: getFormSyncErrors('firstStep')(state),
    firstStepForm: state.form.firstStep
});

const Connected = connect<any, DispatchToProps, any>(mapStateToProps, {
    fetchCalculationData,
    cleanError
})(FirstStep);

export default reduxForm<any>({
    form: 'firstStep',
    destroyOnUnmount: false,
    validate
})(Connected);
